export const tapLog =
    <T>(id: string) =>
    (input: T) => {
        console.log({ [id]: input }); // printing as object handles empty strings better
        return input;
    };
